<script lang="ts">
const LOCK_CUTOUT_SRC = '/icons/svg/lock-filled-closed-cutout.svg'
const LOCK_FILLED_SRC = '/icons/svg/lock-filled-closed.svg'
const DECORATIVE_IMG_ALT = ''
</script>
<script setup lang="ts">import { computed as _computed } from 'vue';

/**
 * Display the incident icon (flag) with status-based color:
 * danger for OPEN/IN_PROGRESS, secondary (muted) for CLOSED.
 * If the incident is restricted, a lock icon is displayed on top of the flag.
 */
import SRoundedIcon, { type SRoundedProps } from '@/components/SRoundedIcon/SRoundedIcon.vue';
import { IncidentLightDto } from '@/api';

type IncidentIconSize = SRoundedProps['size'];

export interface Props {
  size?: IncidentIconSize;
  status?: IncidentLightDto.status;
  restricted?: boolean;
}





const props = defineProps({
  size: { default: 'medium' },
  status: null,
  restricted: { type: Boolean, default: false }
});

const isClosed = _computed(() => props.status === 'CLOSED');
const backgroundColor = _computed(() => (isClosed.value ? 'bgTertiary' : 'bgDangerSecondary'));
const borderColor = _computed(() => (isClosed.value ? 'textTertiary' : 'borderDanger'));
const flagIconColor = _computed(() => (isClosed.value ? 'textSecondary' : 'textDanger'));
</script>

<template lang="pug">
.incident-icon(data-track="incident-icon")
  SRoundedIcon(
    :size="size"
    icon="icon-flag"
    :border-color="borderColor"
    :background-color="backgroundColor"
    :color="flagIconColor")
  span.incident-icon__lock(
    v-if="restricted"
    data-track="incident-icon-lock"
    aria-hidden="true")
    img.incident-icon__lock-cutout(:src="LOCK_CUTOUT_SRC" :alt="DECORATIVE_IMG_ALT")
    img.incident-icon__lock-filled(:src="LOCK_FILLED_SRC" :alt="DECORATIVE_IMG_ALT")
</template>

<style lang="scss" scoped>
.incident-icon {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  align-self: flex-start;
  width: fit-content;
  height: fit-content;
  overflow: visible;
}

.incident-icon__lock {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 14px;
  height: 16px;
  pointer-events: none;
  color: var(--color-text-secondary);
}

.incident-icon__lock-cutout,
.incident-icon__lock-filled {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
}
</style>
